module.exports = __webpack_public_path__ + "media/custom/images/img12-7370b50444ec904bd01a56fbdc54d265.png";